import { FC } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { UpgradeLocation } from "@/lib/tracking";
import useUpgradeCta from "src/hooks/useUpgradeCta";

interface Props {
    location: UpgradeLocation;
    /** What is locked, as a sentence ("Stock Scores are part of ORTEX Advanced."). */
    what: string;
    extra?: Record<string, any>;
}

/**
 * One line under (or over) a locked block: what is locked and a button that is the way in for
 * the viewer's plan (useUpgradeCta). For surfaces that blur or withhold data with nothing to
 * click; a full overlay over a grid is ObfuscationBanner's job.
 */
const UpgradeStrip: FC<Props> = ({ location, what, extra }) => {
    const { isVisitor, label, loading, onClick } = useUpgradeCta(location, extra);

    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1.5,
                p: 1.5,
                my: 1,
                borderRadius: "6px",
                border: "1px solid rgba(128,128,128,0.25)",
                background: "rgba(128,128,128,0.06)",
            }}
        >
            <LockOutlinedIcon sx={{ fontSize: 18, opacity: 0.7 }} />
            <Typography variant="body2" sx={{ flex: "1 1 220px" }}>
                {what}
                {isVisitor ? " Create a free account to get started." : ""}
            </Typography>
            <Button variant="contained" size="small" disabled={loading} onClick={onClick} sx={{ color: "white", textTransform: "none" }}>
                {loading ? <CircularProgress size={16} sx={{ color: "white" }} /> : label}
            </Button>
        </Box>
    );
};

export default UpgradeStrip;
